import FeaturedBadiPlus from './featured-badi-plus-mapping';

export default FeaturedBadiPlus;
